<template>
  <b-container fluid>
    <b-card
      header="오늘의이슈 게시판"
      style="max-width: 50rem; margin: auto; margin-top: 3vh;"
      class="mb-2"
      align="left"
    >
      <b-form-group id="to-do-input">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label-for="filter-input"
              label-cols-sm="6"
              label-align-sm="right"
              label-size="sm"
              class="py-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="검색어 입력"
                  @keyup.enter="callAllListApi(filter)"
                ></b-form-input>

                <b-input-group-append>
                  <b-button @click="callAllListApi(filter)">SEARCH</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="py-0" align="start">
            <b-button size="sm" @click="rowNew()" v-if="isAuthenticated">
              NEW
            </b-button>
          </b-col>
        </b-row>
      </b-form-group>

      <v-list three-line>
        <v-list-item-group v-model="selected" active-class="pink--text" single>
          <template v-for="(item, index) in results" v-if="index < perPage">
            <v-list-item
              :class="{
                notice: item.notice,
              }"
              :key="item.title"
              router
              :to="{
                name: 'todayIssueDetail',
                params: {
                  id: item.id,
                  sort: item.sort,
                  title: item.title,
                  perPage: perPage,
                  scrollY: scrollY,
                },
              }"
            >
              <template v-slot:default="{ active }">
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.title"
                    style="font-weight: bold;"
                  ></v-list-item-title>

                  <v-list-item-subtitle
                    class="text--primary"
                    v-text="
                      item.updateUserName +
                      ' ' +
                      item.date +
                      ' ' +
                      '조회 ' +
                      item.count
                    "
                    style="font-size: 13px;"
                  ></v-list-item-subtitle>

                  <!-- <v-list-item-subtitle
                    v-text="item.contents"
                  ></v-list-item-subtitle> -->
                </v-list-item-content>

                <v-list-item-action>
                  <!-- <v-list-item-action-text v-text="item.date"></v-list-item-action-text> -->

                  <!-- <v-list-item-action-text v-text="'조회 ' + item.count"></v-list-item-action-text> -->
                  <v-list-item-action-text
                    v-text="'댓글 ' + item.replyCount"
                    style="font-size: 14px;"
                  ></v-list-item-action-text>

                  <template v-if="item.replyNewCheck">
                    <v-list-item-action-icon>
                      <v-icon color="red">mdi-new-box</v-icon>
                    </v-list-item-action-icon>
                  </template>
                  <template v-else>
                    <v-list-item-action-text
                      v-text="item.auth == 'viewAll' ? '전체공개' : '나만보기'"
                    ></v-list-item-action-text>
                  </template>
                </v-list-item-action>
              </template>
            </v-list-item>

            <v-divider
              v-if="index < results.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
      <p></p>
      <v-btn class="mx-3" @click="moreView">더 보기</v-btn>

      <Spinner />
    </b-card>

    <!-- <Modal v-on:closeModal="closeModal"></Modal> -->
  </b-container>
</template>

<script>
import Spinner from "../components/Spinner";

import { init, conversion, setSnackBarInfo } from "../js/common_function";

export default {
  components: {
    Spinner,
  },
  data() {
    return {
      perPage: Number(localStorage.getItem("perPage")),
      scrollY: "",
      loading: false,
      selected: [],
      results: [],
      filter: "",
      options: {
        search: true,
        showColumns: true,
      },
      errors: [],
      loginMember: {
        username: "",
        password: "",
      },
      contents: {
        id: "",
        title: "",
        contents: "",
        contentsHTML: "",
        auth: "",
        editable: "",
        editableUse: "",
        isNew: "",
        radioSelectedView: false,
        sort: "",
        replyUse: "",
      },
    };
  },
  computed: {
    rows() {
      return this.results.length;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },

  methods: {
    rowNew: function () {
      this.contents.isNew = true;
      this.contents.editable = true;
      this.contents.editableUse = false;
      this.contents.radioSelectedView = true;
      this.contents.replyUse = false;
      this.contents.remained = false;
      this.contents.open = true;
      this.$parent.$parent.$children.map(function (value, key) {
        if (value.$options._componentTag === "AppBar") {
          value.navTopBar = false;
        }
      });
      this.contents.title = "";
      this.contents.contentsHTML = "";

      this.contents.auth = "viewAll";

      this.contents.sort = "todayIssue";

      if (
        localStorage.getItem("title") !== null ||
        localStorage.getItem("contents") !== null
      ) {
        if (
          localStorage.getItem("title").length !== 0 ||
          localStorage.getItem("contents").length > 7
        ) {
          this.$bvModal
            .msgBoxConfirm("기존에 작성한 글을 불러 오겠습니까?", {
              title: "확인 요청",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              okTitle: "YES",
              cancelTitle: "NO",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            })
            .then((value) => {
              if (value) {
                this.contents.remained = true;
                if (localStorage.getItem("id") !== null) {
                  if (localStorage.getItem("id").length !== 0) {
                    this.contents.id = localStorage.getItem("id");
                    this.contents.isNew = false;
                    this.contents.replyUse = true;
                  }
                } else {
                  this.contents.id = null;
                  this.contents.isNew = true;
                  this.contents.replyUse = false;
                }
                this.contents.title = localStorage.getItem("title");
                this.contents.contentsHTML = localStorage.getItem("contents");
              } else {
                localStorage.removeItem("id");
                localStorage.removeItem("title");
                localStorage.removeItem("contents");
              }
              this.$store
                .dispatch("SET_BULLETIN", this.contents)
                .then((res) => {
                  this.$router.push({
                    name: this.contents.sort + "Detail",
                    params: { id: "new", sort: this.contents.sort },
                  });
                });
            })
            .catch((err) => {
              // An error occurred
              console.log(err);
            });
        } else {
          this.$store.dispatch("SET_BULLETIN", this.contents).then((res) => {
            this.$router.push({
              name: this.contents.sort + "Detail",
              params: { id: "new", sort: this.contents.sort },
            });
          });
        }
      } else {
        this.$store.dispatch("SET_BULLETIN", this.contents).then((res) => {
          this.$router.push({
            name: this.contents.sort + "Detail",
            params: { id: "new", sort: this.contents.sort },
          });
        });
      }
    },

    callAllListApi(searchSet) {
      this.$store.commit("START_SPINNER");
      this.results = [];

      this.$axios({
        url: this.$config.baseBulletinAppURL + "/allBulletinList",
        method: "post",
        data: {
          makeUserName: localStorage.getItem("username"),
          searchSet: searchSet,
          sort: "todayIssue",
          lastLogin: localStorage.getItem("lastLogin"),
        },
        headers: {
          "token-key": localStorage.getItem("token-key"),
        },
      })
        .then((response) => {
          // console.log(response);
          if (response.status === 200) {
            response.data.map(function (value, key) {
              if (value.notice === true) {
                response.data[key].title = "[공지사항] " + value.title;
                response.data[key].notice = true;
              } else {
                response.data[key].notice = false;
              }
            });
            this.results = response.data;
            this.$store.commit("END_SPINNER");
          } else {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("권한이 없습니다.")
            );
            this.$store.commit("END_SPINNER");
          }
        })
        .catch((error) => {
          this.errors.push(error);
          console.log(error);
        });
    },
    moreView() {
      if (this.perPage > this.results.length) {
        this.$store.commit(
          "SET_SNACKBAR",
          setSnackBarInfo("마지막 줄 입니다.")
        );
      } else {
        this.perPage = this.perPage + 20;
      }
    },
    listenScroll() {
      let myScroll = Math.round(
        document.querySelector("#listen").getBoundingClientRect().top
      );
      this.scrollY = myScroll;
    },
  },
  async mounted() {
    this.$parent.$parent.$children.map(function (value, key) {
      if (value.$options._componentTag === "AppBar") {
        value.navTopBar = false;
      }
    });
    const path = this.$route.fullPath;
    // document.body.setAttribute("oncontextmenu", "return false");
    // document.body.setAttribute("onselectstart", "return false");
    // document.body.setAttribute("ondragstart", "return false");
    init(path).then((res) => {
      this.callAllListApi();

      this.$router.afterEach((to, from) => {
        if (
          from.name.substring(from.name.length - 6, from.name.length) ===
          "Detail"
        ) {
          setTimeout(() => {
            window.scrollTo({ left: 0, top: Math.abs(from.params.scrollY) });
          }, 2000);
        }
      });
    });
  },
  created() {
    document.addEventListener("scroll", this.listenScroll);
  },
  destroyed() {
    // remember to remove the listener when destroy the components
    document.removeEventListener("scroll", this.listenScroll);
  },
};
</script>
<style lang="scss">
.notice {
  background-color: antiquewhite;
}
</style>
